var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13813_33404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 6.6665L8.97899 8.65148L11.1695 8.96978L9.58444 10.5149L9.95863 12.6966L7.99935 11.6665L6.04006 12.6966L6.41425 10.5149L4.82916 8.96978L7.01971 8.65148L7.99935 6.6665Z",
    fill: "#006CFA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 10,
    r: 5.33333,
    stroke: "#006CFA",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6673 5.33317L13.724 1.76703C14.0947 1.33458 13.7874 0.666504 13.2178 0.666504H2.78346C2.2139 0.666504 1.90662 1.33458 2.27729 1.76703L5.33398 5.33317",
    stroke: "#006CFA",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13813_33404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank);
export default __webpack_public_path__ + "static/media/rank.95e754f0fb15b97ba325636df87a6d8b.svg";
export { ForwardRef as ReactComponent };